module.exports = __webpack_public_path__ + "static/media/END CAPS BULL NOSE FOR.d9593ff5.jpg";